var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlucs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-flucs_svg__Icon_-_Flucs",
    "data-name": "Icon - Flucs",
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    viewBox: "0 0 12.2 12.2"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon-flucs_svg__Path_5598",
    "data-name": "Path 5598",
    d: "M.5 6.1A5.6 5.6 0 106.1.5 5.6 5.6 0 00.5 6.1",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "icon-flucs_svg__Path_5599",
    "data-name": "Path 5599",
    d: "M9.413 6.321V4.333H7.426",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "icon-flucs_svg__Path_5600",
    "data-name": "Path 5600",
    d: "M9.413 4.333L6.57 7.372a.441.441 0 01-.625 0l-.921-.922a.443.443 0 00-.625 0L2.787 7.867",
    fill: "none",
    stroke: "#737c81",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyBpZD0iSWNvbl8tX0ZsdWNzIiBkYXRhLW5hbWU9Ikljb24gLSBGbHVjcyIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iMTAwJSIKICBoZWlnaHQ9IjEwMCUiIHZpZXdCb3g9IjAgMCAxMi4yIDEyLjIiPgogIDxwYXRoIGlkPSJQYXRoXzU1OTgiIGRhdGEtbmFtZT0iUGF0aCA1NTk4IiBkPSJNLjUsNi4xQTUuNiw1LjYsMCwxLDAsNi4xLjUsNS42LDUuNiwwLDAsMCwuNSw2LjEiCiAgICBmaWxsPSJub25lIiBzdHJva2U9IiM3MzdjODEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIiAvPgogIDxwYXRoIGlkPSJQYXRoXzU1OTkiIGRhdGEtbmFtZT0iUGF0aCA1NTk5IiBkPSJNOS40MTMsNi4zMjFWNC4zMzNINy40MjYiIGZpbGw9Im5vbmUiCiAgICBzdHJva2U9IiM3MzdjODEiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxIiAvPgogIDxwYXRoIGlkPSJQYXRoXzU2MDAiIGRhdGEtbmFtZT0iUGF0aCA1NjAwIgogICAgZD0iTTkuNDEzLDQuMzMzLDYuNTcsNy4zNzJhLjQ0MS40NDEsMCwwLDEtLjYyNSwwTDUuMDI0LDYuNDVhLjQ0My40NDMsMCwwLDAtLjYyNSwwTDIuNzg3LDcuODY3IgogICAgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjNzM3YzgxIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIHN0cm9rZS13aWR0aD0iMSIgLz4KPC9zdmc+";
export { SvgIconFlucs as ReactComponent };